import React from "react"

import BundledPaymentsLayout from "../../components/bundled-payments/layout"
import SectionHero from "../../components/bundled-payments/section-hero"
import SectionResults from "../../components/bundled-payments/section-results"
import SectionThoughtLeadership from "../../components/bundled-payments/section-thought-leadership"
import SectionSummit from "../../components/bundled-payments/section-summit"
import SectionPrograms from "../../components/bundled-payments/section-programs"

const BundledPaymentsIndex = ({ location }) => (
  <BundledPaymentsLayout
    location={location}
    title="Bundled Payments"
    description="Since 2016, Avant-garde Health has helped hospitals lower episode spending and improve quality under Medicare bundled payment models, including CMS TEAM and CJR-X."
    footerNote="Results vary by hospital. Reconciliation outcomes depend on CMS methodology, patient mix, and the actions each hospital takes. Avant-garde Health does not guarantee reconciliation results."
  >
    <SectionHero />
    <SectionResults />
    <SectionThoughtLeadership />
    <SectionSummit />
    <SectionPrograms />
  </BundledPaymentsLayout>
)

export default BundledPaymentsIndex
